import script from "./Congratulations.vue?vue&type=script&setup=true&lang=ts"
export * from "./Congratulations.vue?vue&type=script&setup=true&lang=ts"

import "./Congratulations.vue?vue&type=style&index=0&id=6a4a8969&scoped=true&lang=css"
import "./Congratulations.vue?vue&type=style&index=1&id=6a4a8969&lang=scss&scoped=true"

import exportComponent from "/Users/alessiomealli/WebstormProjects/switaly/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a4a8969"]])

export default __exports__